import { v4 as uuidv4 } from 'uuid';
import logo1 from '../../assets/img/brand/comp1.webp';
import logo2 from '../../assets/img/brand/comp2.webp';
import logo3 from '../../assets/img/brand/comp3.webp';
import logo4 from '../../assets/img/brand/comp4.webp';
import logo5 from '../../assets/img/brand/comp5.webp';
import logo6 from '../../assets/img/brand/comp6.webp';
import logo7 from '../../assets/img/brand/comp7.webp';
import logo8 from '../../assets/img/brand/comp8.webp';
import logo9 from '../../assets/img/brand/comp9.webp';
import logo10 from '../../assets/img/brand/comp10.webp';
import logo11 from '../../assets/img/brand/comp11.webp';
import logo12 from '../../assets/img/brand/comp12.webp';
import logo13 from '../../assets/img/brand/comp13.webp';
import logo14 from '../../assets/img/brand/comp14.webp';
import logo15 from '../../assets/img/brand/comp15.webp';
import logo16 from '../../assets/img/brand/comp16.webp';
import logo17 from '../../assets/img/brand/comp17.webp';
import logo18 from '../../assets/img/brand/comp18.webp';
import logo19 from '../../assets/img/brand/comp19.webp';
import logo20 from '../../assets/img/brand/comp20.webp';
import logo21 from '../../assets/img/brand/comp21.webp';
import logo22 from '../../assets/img/brand/comp22.webp';

const sponsorData = [
    {
        id: uuidv4(),
        sponsorLogo: logo1,
    },

    {
        id: uuidv4(),
        sponsorLogo: logo2,
    },

    {
        id: uuidv4(),
        sponsorLogo: logo3,
    },

    {
        id: uuidv4(),
        sponsorLogo: logo4,
    },

    {
        id: uuidv4(),
        sponsorLogo: logo5,
    },

    {
        id: uuidv4(),
        sponsorLogo: logo6,
    },

    {
        id: uuidv4(),
        sponsorLogo: logo7,
    },

    {
        id: uuidv4(),
        sponsorLogo: logo8,
    },

    {
        id: uuidv4(),
        sponsorLogo: logo9,
    },

    {
        id: uuidv4(),
        sponsorLogo: logo10,
    },
    
    {
        id: uuidv4(),
        sponsorLogo: logo11,
    },
    
    {
        id: uuidv4(),
        sponsorLogo: logo12,
    },
    
    {
        id: uuidv4(),
        sponsorLogo: logo13,
    },
    
    {
        id: uuidv4(),
        sponsorLogo: logo14,
    },
    
    {
        id: uuidv4(),
        sponsorLogo: logo15,
    },
    
    {
        id: uuidv4(),
        sponsorLogo: logo16,
    },
    
    {
        id: uuidv4(),
        sponsorLogo: logo17,
    },
    
    {
        id: uuidv4(),
        sponsorLogo: logo18,
    },
    
    {
        id: uuidv4(),
        sponsorLogo: logo19,
    },
    
    {
        id: uuidv4(),
        sponsorLogo: logo20,
    },
    
    {
        id: uuidv4(),
        sponsorLogo: logo21,
    },
    
    {
        id: uuidv4(),
        sponsorLogo: logo22,
    },
];

export default sponsorData;
